<template>
<!-- Una pagina dedicata alla normativa -->
  <div>
    <PageTagline :elements="tagline_elem"/>

    <!-- Tutorial contestuale per gli argomenti del form. Vengono passati gli slug name dei video da mostrare -->
    <TutorialContestuale :video_to_show="['area_informazioni']"/>

    <!-- CARD PER CONTENERE LA PGINA -->
    <b-card no-body class="mr-1 ml-1">
      <b-card-header>
        <h4><font-awesome-icon icon="info-circle" size="lg"/> Informativa Privacy</h4>
      </b-card-header>
      <b-card-body>
        <b-row class="mb-3">
            <b-col>
              <TestoPrivacy/>
            </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import TutorialContestuale from '@/components/TutorialContestuale'
import TestoPrivacy from '@/components/TestoPrivacy.vue'

export default {
  name: 'CondPrivacy',
  data () {
    return {
      // Variabili generali
      tagline_elem : [ { text : "Condizioni privacy", link : 'cond-privacy' } ],
    }
  },
  components : {
    PageTagline,
    TutorialContestuale,
    TestoPrivacy
  }
}
</script>

<style scoped></style>
